import React, { useEffect, useRef, useState } from "react";
import { setValidationCss } from "../../../common/utils";
import Tooltip from "../Tooltip/Tooltip";
import CurrencyInput from "react-currency-input-field";
import { Controller } from "react-hook-form";
import MaskedInput from "../MaskedInput/MaskedInput";
import parse from "html-react-parser";

function FormInputField({
  fieldName,
  labelClasses,
  inputClassnames,
  placeholder,
  errorMessage,
  register,
  error = "red",
  mainClassnames,
  loading,
  readOnly = false,
  label,
  id,
  type,
  handleChange,
  isAmountField,
  isMultiLineText,
  tooltip,
  value,
  classLabel,
  classQuestion,
  control,
  trigger,
  setValue,
  testId,
  handleAmountField,
  isPercentageField,
  answerType,
  t,
  handleBlur,
  standardQuestionName,
  setFocus,
  handleFocus,
  isGroupQuestion,
  isResubmitTextArea,
  name,
  onChange: rhfOnChange,
  onBlur: rhfOnBlur,
  ref: rhfRef,
  value: rhfValue,
  maxLength,
  underwritingQuestions,
  setWarningLimit,
  publicQuotePurchasePrice,
  purchasePriceLimit
}) {
  const inputRef = useRef(null);
  const textAreaRef = useRef(null);
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const [textVal, setTextVal] = useState(value || "");
  const isControlled =
    typeof rhfValue !== "undefined" || typeof rhfOnChange === "function";

  useEffect(() => {
    if (isControlled) {
      setTextVal(rhfValue ?? "");
    } else {
      setTextVal(value ?? "");
    }
  }, [isControlled, rhfValue, value]);

  const callBothOnChange = (eOrValue) => {
    if (handleChange) {
      if (typeof eOrValue === "object" && eOrValue?.target)
        handleChange(eOrValue);
      else handleChange({ target: { name: fieldName, value: eOrValue } });
    }
    if (rhfOnChange) rhfOnChange(eOrValue);
  };

  useEffect(() => {
    setTextVal(value);
  }, [value]);

  const onPercentChange = (e) => {
    // const percent = e.target.value;
    // if (!percent 
    //   // || 
    //   // percent.match(/^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/)
    // ) {
      callBothOnChange(e);
      if (setValue) setValue(e.target.name, e.target.value);
      if (trigger) trigger(e.target.name);
    // }
  };

  const formatWithSpaces = (str) => str.replace(/[^\d ]/g, "");

  const inputField = () => (
    <>
      <div className={labelClasses + (classLabel ? ` ${classLabel}` : "")}>
        {tooltip ? (
          <span>
            {parse(label)} <Tooltip text={tooltip} />
          </span>
        ) : (
          label
        )}
      </div>

      <div
        className={inputClassnames + (classQuestion ? ` ${classQuestion}` : "")}
      >
        {isAmountField ? (
          <div className={isAmountField ? "custom__icon-textfield" : ""}>
            <Controller
              name={fieldName}
              control={control}
              render={({ field }) => (
                <CurrencyInput
                  {...(register && register(fieldName))}
                  id={fieldName}
                  className={mainClassnames}
                  placeholder={placeholder}
                  value={value || ""}
                  disabled={loading}
                  style={errorMessage ? setValidationCss(error) : {}}
                  onValueChange={(numericValue) => {
                    // Format the currency value
                    const formattedValue =
                      numericValue && numericValue !== undefined
                        ? Number(
                            parseInt(numericValue.replace(/[^0-9]/g, ""), 10) /
                              100,
                          ).toFixed(2)
                        : "";

                    // Cap value at 9000000000.0
                    const cappedValue =
                      formattedValue !== ""
                        ? formattedValue > 9000000000.0
                          ? "9000000000.0"
                          : formattedValue
                        : "";

                    if (underwritingQuestions) {
                      const syntheticEvent = {
                        persist: () => {},
                        target: {
                          name: fieldName,
                          value: cappedValue,
                        },
                      };

                      handleChange(syntheticEvent);
                    } else {
                      if (handleAmountField) {
                        handleAmountField(
                          cappedValue !== undefined ? `${cappedValue}` : "",
                          fieldName,
                        );
                      }
                      field.onChange(`${cappedValue}`);
                      setValue(
                        fieldName,
                        cappedValue !== undefined ? `${cappedValue}` : "",
                      );
                      if (publicQuotePurchasePrice) {
                        if (cappedValue > purchasePriceLimit) {
                          setWarningLimit(true);
                        } else if (cappedValue <= purchasePriceLimit) {
                          setWarningLimit(false);
                        }
                      }
                      trigger(fieldName);
                    }
                  }}
                  data-cy={testId}
                  maxLength={13}
                  allowDecimals
                  decimalsLimit={3}
                  groupSeparator=","
                />
              )}
            />
            {isAmountField ? <div className="icon-box">$</div> : ""}
          </div>
        ) : isPercentageField ? (
          <div className={isPercentageField ? "custom__icon-textfield" : ""}>
            <input
              type="number"
              name={fieldName}
              placeholder={placeholder}
              style={errorMessage ? setValidationCss(error) : {}}
              value={textVal}
              min="0.01"
              step="0.01"
              // max="100.00"
              // presicion={2}
              {...(!isControlled && register ? register(fieldName) : {})}
              onChange={(e) => {
                setTextVal(e.target.value);
                onPercentChange(e);
              }}
              standardquestionname={standardQuestionName}
              ref={isControlled ? rhfRef : inputRef}
              className={mainClassnames}
              onBlur={handleBlur || rhfOnBlur}
              disabled={loading}
              readOnly={readOnly}
            />
            {isPercentageField ? <div className="icon-box">%</div> : ""}
          </div>
        ) : (
          <>
            {value || value === "" ? (
              <div className={isAmountField ? "custom__icon-textfield" : ""}>
                {isMultiLineText ? (
                  <div>
                    <textarea
                      type={type}
                      id={id}
                      data-cy={testId}
                      {...register(fieldName)}
                      placeholder={placeholder}
                      className={
                        mainClassnames +
                        " " +
                        (errorMessage ? "txtAreaError" : "")
                      }
                      style={errorMessage ? setValidationCss(error) : {}}
                      ref={textAreaRef}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.stopPropagation();
                      }}
                      disabled={loading}
                      value={textVal}
                      readOnly={readOnly}
                      onChange={(e) => {
                        setTextVal(e.target.value);
                        callBothOnChange(e);
                        if (!isResubmitTextArea) {
                          const textArea = textAreaRef.current;
                          if (textArea) {
                            textArea.style.height = "auto";
                            textArea.style.height = `${textArea.scrollHeight}px`;
                          }
                        }
                      }}
                      standardquestionname={standardQuestionName}
                      onBlur={handleBlur || rhfOnBlur}
                    />
                  </div>
                ) : answerType === "PhoneNumber" ? (
                  <>
                    <MaskedInput
                      placeholder="(000) 000-0000"
                      register={register}
                      mask="(999) 999-9999"
                      handleChange={(e) => callBothOnChange(e)}
                      className={mainClassnames}
                      name={fieldName}
                      errors={errorMessage ? error : ""}
                      t={t}
                      value={textVal}
                      disabled={loading}
                    />
                  </>
                ) : (
                  <input
                    type={type}
                    id={id}
                    data-cy={testId}
                    onKeyDown={
                      type === "number"
                        ? (e) =>
                            exceptThisSymbols.includes(e.key) &&
                            e.preventDefault()
                        : null
                    }
                    {...register(fieldName)}
                    maxLength={maxLength || "100"}
                    placeholder={placeholder}
                    className={mainClassnames}
                    style={errorMessage ? setValidationCss(error) : {}}
                    disabled={loading}
                    readOnly={readOnly}
                    value={textVal}
                    onChange={(e) => {
                      let next = e;
                      setTextVal(e.target.value);
                      if (
                        String(id)?.substring(
                          String(id)?.lastIndexOf(".") + 1,
                        ) === "DivisionNum"
                      ) {
                        const formatted = formatWithSpaces(e.target.value);
                        next = {
                          ...e,
                          target: {
                            ...e.target,
                            value: formatted,
                            name: e.target.name,
                          },
                        };
                        setTextVal(formatted);
                      }
                      callBothOnChange(next);
                    }}
                    onBlur={handleBlur || rhfOnBlur}
                    standardquestionname={standardQuestionName}
                    ref={isControlled ? rhfRef : inputRef}
                    onFocus={handleFocus}
                  />
                )}
                {isAmountField ? <div className="icon-box">$</div> : ""}
              </div>
            ) : (
              <div className={isAmountField ? "custom__icon-textfield" : ""}>
                {isMultiLineText ? (
                  <div>
                    <textarea
                      type={type}
                      id={id}
                      data-cy={testId}
                      ref={textAreaRef}
                      {...register(fieldName)}
                      placeholder={placeholder}
                      className={
                        mainClassnames +
                        " " +
                        (errorMessage ? "txtAreaError" : "")
                      }
                      style={errorMessage ? setValidationCss(error) : {}}
                      disabled={loading}
                      readOnly={readOnly}
                      value={textVal}
                      onChange={(e) => {
                        setTextVal(e.target.value);
                        callBothOnChange(e);
                        if (!isResubmitTextArea) {
                          const textArea = textAreaRef.current;
                          if (textArea) {
                            textArea.style.height = "auto";
                            textArea.style.height = `${textArea.scrollHeight}px`;
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.stopPropagation();
                      }}
                      standardquestionname={standardQuestionName}
                      onBlur={handleBlur || rhfOnBlur}
                    />
                  </div>
                ) : answerType === "PhoneNumber" ? (
                  <>
                    <MaskedInput
                      placeholder="(000) 000-0000"
                      register={register}
                      mask="(999) 999-9999"
                      handleChange={(e) => callBothOnChange(e)}
                      data-cy={testId}
                      name={fieldName}
                      errors={errorMessage ? error : ""}
                      t={t}
                      disabled={loading}
                      value={textVal}
                    />
                  </>
                ) : (
                  <input
                    type={type}
                    id={id}
                    data-cy={testId}
                    onKeyDown={
                      type === "number"
                        ? (e) =>
                            exceptThisSymbols.includes(e.key) &&
                            e.preventDefault()
                        : null
                    }
                    {...register(fieldName)}
                    maxLength={maxLength || "100"}
                    placeholder={placeholder}
                    className={mainClassnames}
                    style={errorMessage ? setValidationCss(error) : {}}
                    disabled={loading}
                    readOnly={readOnly}
                    value={textVal}
                    onChange={(e) => {
                      setTextVal(e.target.value);
                      callBothOnChange(e);
                      if (trigger && id) trigger(id);
                    }}
                    onBlur={handleBlur || rhfOnBlur}
                    standardquestionname={standardQuestionName}
                    ref={isControlled ? rhfRef : inputRef}
                    onFocus={handleFocus}
                  />
                )}
                {isAmountField ? <div className="icon-box">$</div> : ""}
              </div>
            )}
          </>
        )}
        {t !== undefined && (
          <span className="font-semibold text-secondary-red">
            {errorMessage && textVal?.length > 0 && t(placeholder)}
          </span>
        )}
      </div>
    </>
  );

  return isGroupQuestion ? <div>{inputField()}</div> : inputField();
}

export default FormInputField;
